module.exports = __webpack_public_path__ + "img/andrology.73aa10b2.png";